import { useContext } from 'react';
import { Dispatch } from 'redux';

import ReduxStoreContext from './ReduxStoreContext';

const useReduxStoreContext = (): {
  reduxStore: {
    dispatch: Dispatch;
    getState: () => Record<string, any>;
    subscribe: (listener: () => void) => () => void;
  };
} => {
  const store = useContext(ReduxStoreContext);
  if (!store) throw new Error('ReduxStoreContext has no store defined');
  return store;
};

export default useReduxStoreContext;
